import React, { Component } from 'react';

import Helmet from './Helmet';

export default class FourOhFourHelmet extends Component {
  render() {
    return <Helmet title="Page Not Found | Canny" />;
  }
}
